import { useEffect, useState } from "react";
import { WA_NUMBER_DISPLAY, waLink, DEFAULT_WA_MSG } from "../data/catalogue";
import { WhatsAppIcon, scrollToSection } from "./Shared";

const LINKS = [
  { label: "Collections", hash: "#collections" },
  { label: "Spotlight", hash: "#spotlight" },
  { label: "How it works", hash: "#how" },
  { label: "Quantities", hash: "#moq" },
];

const LogoMark = () => (
  <img
    src="/anubandh-logo.jpg"
    alt="Anubandh logo"
    className="h-11 w-11 rounded-full object-cover border-2 border-peach shadow-sm"
  />
);

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, hash) => {
    e.preventDefault();
    scrollToSection(hash);
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-cream/85 backdrop-blur-xl border-b border-sand shadow-[0_8px_30px_rgba(43,33,28,0.06)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo-link"
          onClick={(e) => go(e, "#top")}
          className="flex items-center gap-3"
        >
          <LogoMark />
          <span className="leading-none">
            <span className="font-display text-xl text-coral block">अनुबंध</span>
            <span className="text-[10px] tracking-[0.28em] uppercase text-cocoa block mt-0.5">
              Anubandh
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.hash}
              href={l.hash}
              data-testid={`nav-link-${l.hash.slice(1)}`}
              onClick={(e) => go(e, l.hash)}
              className="text-sm font-medium text-cocoa hover:text-coral transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={waLink(DEFAULT_WA_MSG)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-whatsapp-cta"
          className="inline-flex items-center gap-2 rounded-full bg-espresso text-cream px-4 sm:px-5 py-2.5 text-sm font-medium hover:bg-coral transition-colors duration-300"
        >
          <WhatsAppIcon className="h-4 w-4" />
          <span className="hidden sm:inline">{WA_NUMBER_DISPLAY}</span>
          <span className="sm:hidden">WhatsApp</span>
        </a>
      </div>
    </header>
  );
}
